import { render } from "./NewDashboardView.vue?vue&type=template&id=186f08e7&scoped=true"
import script from "./NewDashboardView.vue?vue&type=script&lang=js"
export * from "./NewDashboardView.vue?vue&type=script&lang=js"

import "./NewDashboardView.vue?vue&type=style&index=0&id=186f08e7&scoped=true&lang=scss"

import exportComponent from "/opt/tracking-bg-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-186f08e7"]])

export default __exports__